import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FeedPage } from "@/pages/feed";
import { PostPage } from "@/pages/post";
import { SavedPage } from "@/pages/saved";
import { NotFoundPage } from "@/pages/not-found";
import { ErrorBoundary } from "@/components/ErrorBoundary";
const queryClient = new QueryClient();

import { TopAppBar } from "@/components/TopAppBar";
import { Footer } from "@/components/Footer";

function HackerNewsLayout() {
  return (
    <>
      <TopAppBar />
      <main className="pt-24 pb-24 px-4 max-w-[1440px] mx-auto min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <div className="min-h-screen bg-background text-foreground transition-colors font-sans selection:bg-secondary selection:text-on-secondary">
          <ErrorBoundary>
            <Routes>
            {/* Redirect root to HN feed */}
            <Route path="/" element={<Navigate to="/hn" replace />} />

            <Route path="/profile" element={<Navigate to="/hn" replace />} />
            <Route path="/submit" element={<Navigate to="/hn" replace />} />
            <Route path="/signup" element={<Navigate to="/hn" replace />} />
            <Route path="/login" element={<Navigate to="/hn" replace />} />
            
            <Route path="/hn" element={<HackerNewsLayout />}>
              <Route index element={<FeedPage feedType="topstories" title="Top Stories" />} />
              <Route path="newest" element={<FeedPage feedType="newstories" title="Newest" />} />
              <Route path="ask" element={<FeedPage feedType="askstories" title="Ask HN" />} />
              <Route path="show" element={<FeedPage feedType="showstories" title="Show HN" />} />
              <Route path="jobs" element={<FeedPage feedType="jobstories" title="Jobs" />} />
              <Route path="post/:id" element={<PostPage />} />
              <Route path="saved" element={<SavedPage />} />
            </Route>

            {/* Catch-all 404 Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </ErrorBoundary>
        </div>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
